// Product Page JavaScript
// Mobile-optimized functionality for Two Brothers Organic Farms

document.addEventListener('DOMContentLoaded', function() {
  initializeProductPage();
});

function initializeProductPage() {
  setupImageGallery();
  setupQuantityControls();
  setupVariantSelection();
  setupTabNavigation();
  setupFAQAccordion();
  setupMobileCartBar();
  setupIntersectionObserver();
}

// Image Gallery Functions
function setupImageGallery() {
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.getElementById('main-product-image');
  
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const imageUrl = this.querySelector('img').src.replace('width=100', 'width=600');
      changeMainImage(imageUrl, this);
    });
  });
  
  // Touch swipe for main image (mobile)
  if ('ontouchstart' in window) {
    let startX = 0;
    let currentIndex = 0;
    const images = Array.from(thumbnails).map(thumb => 
      thumb.querySelector('img').src.replace('width=100', 'width=600')
    );
    
    mainImage.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    mainImage.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) {
        if (diff > 0 && currentIndex < images.length - 1) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }
        
        mainImage.src = images[currentIndex];
        updateActiveThumbnail(currentIndex);
      }
    }, { passive: true });
  }
}

function changeMainImage(imageUrl, clickedThumbnail) {
  const mainImage = document.getElementById('main-product-image');
  mainImage.src = imageUrl;
  
  // Update active thumbnail
  document.querySelectorAll('.thumbnail').forEach(thumb => 
    thumb.classList.remove('active')
  );
  
  if (clickedThumbnail) {
    clickedThumbnail.classList.add('active');
  }
}

function updateActiveThumbnail(index) {
  document.querySelectorAll('.thumbnail').forEach((thumb, i) => {
    thumb.classList.toggle('active', i === index);
  });
}

// Quantity Controls
function setupQuantityControls() {
  const quantityInput = document.getElementById('quantity');
  const bottomQuantity = document.getElementById('bottom-quantity');
  
  // Sync bottom cart quantity with main quantity
  if (quantityInput && bottomQuantity) {
    quantityInput.addEventListener('change', () => {
      bottomQuantity.textContent = quantityInput.value;
    });
  }
}

function increaseQuantity() {
  const quantityInput = document.getElementById('quantity');
  const bottomQuantity = document.getElementById('bottom-quantity');
  let currentValue = parseInt(quantityInput.value);
  
  if (currentValue < 99) { // Set maximum limit
    currentValue++;
    quantityInput.value = currentValue;
    if (bottomQuantity) bottomQuantity.textContent = currentValue;
    updateCartButton();
  }
}

function decreaseQuantity() {
  const quantityInput = document.getElementById('quantity');
  const bottomQuantity = document.getElementById('bottom-quantity');
  let currentValue = parseInt(quantityInput.value);
  
  if (currentValue > 1) {
    currentValue--;
    quantityInput.value = currentValue;
    if (bottomQuantity) bottomQuantity.textContent = currentValue;
    updateCartButton();
  }
}

// Variant Selection
function setupVariantSelection() {
  const variantInputs = document.querySelectorAll('input[name="variant"]');
  
  variantInputs.forEach(input => {
    input.addEventListener('change', function() {
      updateProductInfo(this.value);
      updateVariantUI(this);
    });
  });
}

function updateProductInfo(variantId) {
  // This would typically fetch variant data from Shopify
  // For now, we'll simulate the update
  try {
    const productData = window.productData || {};
    const variant = productData.variants?.find(v => v.id == variantId);
    
    if (variant) {
      // Update price
      const priceElement = document.querySelector('.price-current');
      if (priceElement && variant.price) {
        priceElement.textContent = `₹${(variant.price / 100).toFixed(0)}`;
      }
      
      // Update compare at price
      const originalPriceElement = document.querySelector('.price-original');
      if (originalPriceElement && variant.compare_at_price) {
        originalPriceElement.textContent = `₹${(variant.compare_at_price / 100).toFixed(0)}`;
      }
      
      // Update main image if variant has image
      if (variant.featured_image) {
        changeMainImage(variant.featured_image.src);
      }
      
      // Update availability
      updateAvailability(variant.available);
    }
  } catch (error) {
    console.error('Error updating product info:', error);
  }
}

function updateVariantUI(selectedInput) {
  // Update variant option styling
  document.querySelectorAll('.variant-option').forEach(option => 
    option.classList.remove('active')
  );
  
  selectedInput.closest('.variant-option').classList.add('active');
}

function updateAvailability(isAvailable) {
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const bottomCartBtn = document.querySelector('.bottom-add-to-cart');
  
  if (isAvailable) {
    addToCartBtn?.removeAttribute('disabled');
    bottomCartBtn?.removeAttribute('disabled');
    addToCartBtn && (addToCartBtn.textContent = 'ADD TO CART');
    bottomCartBtn && (bottomCartBtn.textContent = 'ADD TO CART');
  } else {
    addToCartBtn?.setAttribute('disabled', 'disabled');
    bottomCartBtn?.setAttribute('disabled', 'disabled');
    addToCartBtn && (addToCartBtn.textContent = 'SOLD OUT');
    bottomCartBtn && (bottomCartBtn.textContent = 'SOLD OUT');
  }
}

// Tab Navigation
function setupTabNavigation() {
  const tabHeaders = document.querySelectorAll('.tab-header');
  const tabPanels = document.querySelectorAll('.tab-panel');
  
  tabHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const tabName = this.dataset.tab;
      
      // Remove active class from all headers and panels
      tabHeaders.forEach(h => h.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      
      // Add active class to clicked header and corresponding panel
      this.classList.add('active');
      const targetPanel = document.getElementById(tabName);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
      
      // Smooth scroll to content (mobile)
      if (window.innerWidth < 768) {
        targetPanel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

// FAQ Accordion
function setupFAQAccordion() {
  const faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', function() {
      toggleFaq(this);
    });
  });
}

function toggleFaq(button) {
  const faqItem = button.parentElement;
  const answer = faqItem.querySelector('.faq-answer');
  const icon = button.querySelector('.faq-icon');
  const isActive = faqItem.classList.contains('active');
  
  // Close all other FAQ items
  document.querySelectorAll('.faq-item').forEach(item => {
    if (item !== faqItem && item.classList.contains('active')) {
      item.classList.remove('active');
      const otherAnswer = item.querySelector('.faq-answer');
      const otherIcon = item.querySelector('.faq-icon');
      otherAnswer.style.maxHeight = '0';
      otherIcon.textContent = '+';
    }
  });
  
  // Toggle current FAQ item
  faqItem.classList.toggle('active');
  
  if (!isActive) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    icon.textContent = '−';
  } else {
    answer.style.maxHeight = '0';
    icon.textContent = '+';
  }
}

// Mobile Cart Bar
function setupMobileCartBar() {
  const bottomCartBar = document.querySelector('.bottom-cart-bar');
  const productInfo = document.querySelector('.product-info');
  
  if (!bottomCartBar || !productInfo) return;
  
  // Show/hide bottom cart bar based on product info visibility
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        bottomCartBar.style.transform = 'translateY(100%)';
      } else {
        bottomCartBar.style.transform = 'translateY(0)';
      }
    });
  }, {
    threshold: 0.5
  });
  
  observer.observe(productInfo);
}

// Cart Functions
function addToCart() {
  const variantId = getSelectedVariantId();
  const quantity = parseInt(document.getElementById('quantity').value);
  
  if (!variantId) {
    showErrorMessage('Please select a product option');
    return;
  }
  
  // Show loading state
  setCartButtonLoading(true);
  
  const cartData = {
    id: variantId,
    quantity: quantity,
    properties: gatherProductProperties()
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(cartData)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    handleCartSuccess(data);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    handleCartError(error);
  })
  .finally(() => {
    setCartButtonLoading(false);
  });
}

function getSelectedVariantId() {
  const checkedVariant = document.querySelector('input[name="variant"]:checked');
  return checkedVariant ? checkedVariant.value : null;
}

function gatherProductProperties() {
  // Gather any additional product properties
  const properties = {};
  
  // Add gift message if present
  const giftMessage = document.querySelector('textarea[name="gift_message"]');
  if (giftMessage && giftMessage.value.trim()) {
    properties['Gift Message'] = giftMessage.value.trim();
  }
  
  return properties;
}

function setCartButtonLoading(isLoading) {
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const bottomCartBtn = document.querySelector('.bottom-add-to-cart');
  
  if (isLoading) {
    addToCartBtn && (addToCartBtn.textContent = 'ADDING...');
    bottomCartBtn && (bottomCartBtn.textContent = 'ADDING...');
    addToCartBtn?.setAttribute('disabled', 'disabled');
    bottomCartBtn?.setAttribute('disabled', 'disabled');
  } else {
    addToCartBtn && (addToCartBtn.textContent = 'ADD TO CART');
    bottomCartBtn && (bottomCartBtn.textContent = 'ADD TO CART');
    addToCartBtn?.removeAttribute('disabled');
    bottomCartBtn?.removeAttribute('disabled');
  }
}

function handleCartSuccess(data) {
  updateCartCount();
  showSuccessMessage('Product added to cart!');
  
  // Optional: Show mini cart or redirect
  if (window.miniCart) {
    window.miniCart.open();
  }
}

function handleCartError(error) {
  let errorMessage = 'Failed to add product to cart';
  
  if (error.message.includes('422')) {
    errorMessage = 'This product is currently out of stock';
  } else if (error.message.includes('404')) {
    errorMessage = 'Product not found';
  }
  
  showErrorMessage(errorMessage);
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
        element.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Related Products
function addRelatedToCart(productHandle) {
  console.log('Adding related product to cart:', productHandle);
  // Implement related product add to cart logic
}

// Notifications
function showSuccessMessage(message) {
  showNotification(message, 'success');
}

function showErrorMessage(message) {
  showNotification(message, 'error');
}

function showNotification(message, type = 'success') {
  // Remove existing notifications
  document.querySelectorAll('.cart-notification').forEach(n => n.remove());
  
  const notification = document.createElement('div');
  notification.className = `cart-notification ${type}`;
  notification.textContent = message;
  
  // Add appropriate styling based on type
  if (type === 'error') {
    notification.style.background = 'var(--color-red-500)';
  }
  
  document.body.appendChild(notification);
  
  // Auto-hide after 3 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
  
  // Allow manual dismissal
  notification.addEventListener('click', () => {
    notification.style.opacity = '0';
    setTimeout(() => notification.remove(), 300);
  });
}

// Newsletter Subscription
function subscribeNewsletter(event) {
  event.preventDefault();
  
  const form = event.target;
  const email = form.querySelector('input[type="email"]').value;
  const submitButton = form.querySelector('button[type="submit"]');
  
  // Basic email validation
  if (!isValidEmail(email)) {
    showErrorMessage('Please enter a valid email address');
    return;
  }
  
  // Show loading state
  const originalText = submitButton.textContent;
  submitButton.textContent = '...';
  submitButton.disabled = true;
  
  // Submit to newsletter service (implement based on your setup)
  fetch('/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      'contact[email]': email,
      'contact[tags]': 'newsletter'
    })
  })
  .then(response => {
    if (response.ok) {
      showSuccessMessage('Successfully subscribed to newsletter!');
      form.reset();
    } else {
      throw new Error('Subscription failed');
    }
  })
  .catch(error => {
    console.error('Newsletter subscription error:', error);
    showErrorMessage('Failed to subscribe. Please try again.');
  })
  .finally(() => {
    submitButton.textContent = originalText;
    submitButton.disabled = false;
  });
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

// Video Functions
function playVideo(videoId) {
  console.log('Playing video:', videoId);
  // Implement video playback logic
  // This could open a modal with the video or navigate to video page
}

// Intersection Observer for animations
function setupIntersectionObserver() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
      }
    });
  }, observerOptions);
  
  // Observe elements that should animate in
  const elementsToObserve = document.querySelectorAll(
    '.recommended-item, .faq-item, .video-item'
  );
  
  elementsToObserve.forEach(element => {
    observer.observe(element);
  });
}

// Utility Functions
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// Performance optimization for mobile
function updateCartButton() {
  // Debounced function to update cart button state
  const debouncedUpdate = debounce(() => {
    const quantity = parseInt(document.getElementById('quantity').value);
    const buttons = document.querySelectorAll('.add-to-cart-btn, .bottom-add-to-cart');
    
    buttons.forEach(button => {
      if (quantity > 0) {
        button.disabled = false;
        button.classList.remove('disabled');
      } else {
        button.disabled = true;
        button.classList.add('disabled');
      }
    });
  }, 100);
  
  debouncedUpdate();
}

// Error handling
window.addEventListener('error', (event) => {
  console.error('JavaScript error:', event.error);
  // You could send errors to a logging service here
});

// Handle network errors gracefully
window.addEventListener('online', () => {
  showSuccessMessage('Connection restored');
});

window.addEventListener('offline', () => {
  showErrorMessage('No internet connection');
});

// Export functions for global access
window.productPageFunctions = {
  changeMainImage,
  increaseQuantity,
  decreaseQuantity,
  toggleFaq,
  addToCart,
  addRelatedToCart,
  subscribeNewsletter,
  playVideo
};